import { Pivot, PivotItem } from "@fluentui/react";
import DOMPurify from "dompurify";

import styles from "./AnalysisPanel.module.css";

import { SupportingContent } from "../SupportingContent";
import { AskResponse } from "api";
import { AnalysisPanelTabs } from "./AnalysisPanelTabs";

interface Props {
  className: string;
  activeTab: AnalysisPanelTabs;
  onActiveTabChanged: (tab: AnalysisPanelTabs) => void;
  activeCitation: string | undefined;
  citationHeight: string;
  answer: AskResponse;
}

const pivotItemDisabledStyle = { disabled: true, primaryDisabled: true };

export const AnalysisPanel = ({
  answer,
  activeTab,
  activeCitation,
  citationHeight,
  className,
  onActiveTabChanged,
}: Props) => {
  const isDisabledThoughtProcessTab: boolean = !answer.thoughts;
  const isDisabledSupportingContentTab: boolean = !answer?.data_points?.length;
  const isDisabledCitationTab: boolean = !activeCitation;

  const sanitizedThoughts = DOMPurify.sanitize(answer.thoughts!);

  return (
    <Pivot
      className={className}
      selectedKey={activeTab}
      onLinkClick={(pivotItem) =>
        pivotItem &&
        onActiveTabChanged(pivotItem.props.itemKey! as AnalysisPanelTabs)
      }
    >
      <PivotItem
        className={styles.chatAnalysisPivotItem}
        itemKey={AnalysisPanelTabs.ThoughtProcessTab}
        headerText="Thought process"
        headerButtonProps={
          isDisabledThoughtProcessTab ? pivotItemDisabledStyle : undefined
        }
      >
        <div
          className={styles.thoughtProcess}
          dangerouslySetInnerHTML={{ __html: sanitizedThoughts }}
        ></div>
      </PivotItem>
      <PivotItem
        className={styles.chatAnalysisPivotItem}
        itemKey={AnalysisPanelTabs.SupportingContentTab}
        headerText="Supporting content"
        headerButtonProps={
          isDisabledSupportingContentTab ? pivotItemDisabledStyle : undefined
        }
      >
        {answer.data_points && (
          <SupportingContent supportingContent={answer.data_points} />
        )}
      </PivotItem>
      <PivotItem
        className={styles.chatAnalysisPivotItem}
        itemKey={AnalysisPanelTabs.CitationTab}
        headerText="Citation"
        headerButtonProps={
          isDisabledCitationTab ? pivotItemDisabledStyle : undefined
        }
      >
        <iframe
          style={{ marginTop: 12 }}
          title="Citation"
          src={activeCitation}
          width="100%"
          height={citationHeight}
        />
      </PivotItem>
    </Pivot>
  );
};
